import { Typography, TextField, Grid } from "@mui/material";
import Button from "../common/Button";
import React, { useState, useEffect } from "react";
import "./instrutor.scss";
import { styled } from "@mui/material/styles";
import { Stack } from "@mui/system";
import { Box, Switch } from "@mui/material";
import SearchBar from "../common/searchBar";
import InstructorCardView from "./InstructorCardView";
import InstructorList from "./InstructorList";
import DateRangePicker from "../TP_DateRangePicker";
import Dropdown from "../../components/TP_Dropdown";
import InstructorDetails from "./InstructorDetails";
import axios from "../../globals/common_utilities/axios_old";
import CONSTANTURL from "../../globals/common_utilities/constanturls";
import { API, FOMRS, APP_ROUTES } from "../../globals/constants";
import {
  setcheckedList,
  setemptyDeleteList,
  setemptycheckedList,
} from "../../redux/features/instructor";
import ToggleButton from "../ToggleButton";
import { useDispatch, useSelector } from "react-redux";
import Loading from "../loader";
import CsvDownloader from "react-csv-downloader";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import Pagination from "@mui/material/Pagination";
import SubHeading from "../common/SubHeading";
import Cookies from "universal-cookie";
import MultiLine_Spinner from "../multiline_spinner/Multiline_spinner";
import DeleteAlert from "../DeleteAlert/DeleteModal";
import SingleDelete from "../SingleDeleteAlert/SingleDelete";
import { StackedBarChart } from "@mui/icons-material";
import moment from "moment";

const Instructor = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [pageCount, setPageCount] = useState();
  const [checked, setChecked] = useState(false);
  const [showFilter, setShowFilter] = useState(false);
  const [showDateFilter, setShowDateFilter] = useState(false);
  const [showDetails, setShowDetails] = useState(false);
  const [apiResponse, setApiResponse] = useState([]);
  const [exportapiResponse, setexportApiResponse] = useState([]);
  const [loading, setloading] = useState(true);
  const [flag, setFlag] = useState(true);
  const [loadApi, setloadApi] = useState(false);
  const [selectLocation, setSelectLocation] = useState([]);
  const [allTC, setAllTC] = useState([]);
  const [allInst, setALLInst] = useState([]);
  const limit = 12;
  const [showModal, setShowModal] = useState(false);
  const [showSingleModal, setShowSingleModal] = useState(false);
  const [singleDeleteId, setSingleDeleteId] = useState();
  let currentDate = new Date();

  let previousDate = new Date();
  let lastday = previousDate.setDate(previousDate.getDate() - 7);
  const [queryParamas, setqueryParamas] = useState({
    limit: limit || 10,
    offset: 0,
    is_active: true,
    role_id: 3,
    // from_date: moment(previousDate).format('YYYY-MM-DD'),
    // end_date: moment(currentDate).format('YYYY-MM-DD'),
  });

  const cookies = new Cookies();
  const loginData = cookies.get("loginData");
  let userID = loginData?.id;
  let userRole = loginData?.role_code;
  let userStudioID = loginData?.studio_id;

  const apiCall = async () => {
    const name_Key = "name" in queryParamas;
    if (name_Key) {
      delete queryParamas.offset;
    }
    queryParamas.limit = 12;
    setloading(true);
    if (userRole === "STUDIO_ADMIN") {
      const response = await axios(
        "GET",
        CONSTANTURL[process.env.REACT_APP_CUSTOM_ENV].LOGIN +
          API.END_POINTS.STUDIOADMIN_INSTRUCTOR_ENDPOINT +
          `?` +
          `studio_id=${userStudioID}` +
          `&` +
          `unique_id=${userStudioID}` +
          `&` +
          `role_id=3`,
        queryParamas,
        {},
        {}
      ).then((response) => {
        console.log("Instructor", response?.data?.data?.rows);
        setApiResponse(response?.data?.data?.rows);
        setALLInst(response?.data?.allIns);
        console.log("allInt", allInst);
        setPageCount(() => Math.ceil(response?.data?.data?.count / limit));
        setloading(false);
        return response.data;
      });
    } else {
      const response = await axios(
        "GET",
        CONSTANTURL[process.env.REACT_APP_CUSTOM_ENV].LOGIN +
          API.END_POINTS.INSTRUCTOR_ENDPOINT,
        queryParamas,
        {},
        {}
      ).then((response) => {
        console.log("Instructor", response?.data?.data?.rows);
        setApiResponse(response?.data?.data?.rows);
        setPageCount(() => Math.ceil(response?.data?.data?.count / limit));
        setloading(false);
        setALLInst(response?.data?.allIns);
        console.log("allInt", allInst);
        return response.data;
      });
    }
  };

  const exportapiCall = async () => {
    let qp = queryParamas;
    const from_date_Key = "from_date" in qp;
    const end_date_Key = "end_date" in qp;
    const name_Key = "name" in qp;
    const studio_id_Key = "studio_id" in qp;

    if (from_date_Key || end_date_Key || name_Key || studio_id_Key) {
      delete qp.limit;
      delete qp.offset;
    }
    if (userRole === "STUDIO_ADMIN") {
      const response = await axios(
        "GET",
        CONSTANTURL[process.env.REACT_APP_CUSTOM_ENV].LOGIN +
          API.END_POINTS.STUDIOADMIN_INSTRUCTOR_ENDPOINT +
          `?` +
          `studio_id=${userStudioID}` +
          `&` +
          `unique_id=${userStudioID}` +
          `&` +
          `role_id=3`,
        qp,
        {},
        {}
      ).then((response) => {
        console.log("Instructor", response?.data?.data?.rows);
        setexportApiResponse(response?.data?.data?.rows);
        setALLInst(response?.data?.allIns);
        console.log("allInt", allInst);
        // setPageCount(() => Math.ceil(response?.data?.data?.count / limit));
        setloading(false);
        return response.data;
      });
    } else {
      const response = await axios(
        "GET",
        CONSTANTURL[process.env.REACT_APP_CUSTOM_ENV].LOGIN +
          API.END_POINTS.INSTRUCTOR_ENDPOINT,
        qp,
        {},
        {}
      ).then((response) => {
        console.log("Instructor", response?.data?.data?.rows);
        setexportApiResponse(response?.data?.data?.rows);
        // setPageCount(() => Math.ceil(response?.data?.data?.count / limit));
        setloading(false);
        setALLInst(response?.data?.allIns);
        console.log("allInt", allInst);
        return response.data;
      });
    }
  };

  const onPageClickhandler = (e, data) => {
    setqueryParamas((prevState) => ({
      ...prevState,
      offset: Math.ceil((data - 1) * limit),
    }));
  };

  const getAllTC = async () => {
    const response = await axios(
      "GET",
      CONSTANTURL[process.env.REACT_APP_CUSTOM_ENV].STUDIO +
        API.END_POINTS.STUDIO_LIST +
        `?` +
        `is_active=true`,
      {},
      {},
      {}
    )
      .then((response) => {
        console.log("response", response?.data?.data?.rows);
        const list = response?.data?.data?.rows?.map((value) => ({
          id: value?.id,
          value: value?.studio_name,
          label: value?.studio_name,
        }));
        setAllTC(list);
        console.log("allTC0", allTC);
      })
      .catch((err) => {
        console.log("err::", err);
        toast.error("LOCATION NOT FOUND", {
          position: "bottom-right",
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          style: { background: "#000", color: "#ffffff" },
        });
      });
  };

  let instructorDetails = useSelector(
    (state) => state.instructorDetails?.showdetails
  );

  let multipleDelete = useSelector(
    (state) => state.instructorDetails?.deleteList
  );

  let multipleChecked = useSelector(
    (state) => state.instructorDetails?.checkedList
  );

  let studioName = allInst?.map((value) => ({
    id: value?.id,
    value: value.name,
    label: value.name,
  }));

  let uniqueName = [
    ...new Map(studioName?.map((item) => [item["value"], item])).values(),
  ];

  let instructor = apiResponse?.map((value) => ({
    id: value?.[`studio.id`],
    value: value?.[`studio.studio_name`],
    label: value?.[`studio.studio_name`],
  }));

  let uniqueInstructor = [
    ...new Map(instructor?.map((item) => [item["value"], item])).values(),
  ];

  // const dropdownSelectInstructor=async(getInstructor)=>{

  // }

  const dropdownSelectInstructor = (StudioName) => {
    console.log("searchStudio", StudioName);
    let params = queryParamas;

    StudioName?.value
      ? (params.name = `${StudioName?.value}`)
      : delete params.name;
    setqueryParamas({ ...params });
  };

  const dropdownSelect = (getName) => {
    console.log("trainingCenter", getName);
    let params = queryParamas;
    getName?.id
      ? (params.studio_id = `${getName?.id}`)
      : delete params.studio_id;
    console.log("params", params);
    setqueryParamas({ ...params });
  };

  const singleDelete = (list) => {
    setSingleDeleteId(list);
    setShowSingleModal(true);
  };

  const multipleDeleteList = (list) => {
    console.log("deleteList", list);

    if (multipleDelete.length < 1) {
      toast.error("Select Records To Delete", {
        position: "bottom-right",
        autoClose: 3000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        style: { background: "#000", color: "#ffffff" },
      });
    } else {
      setShowModal(true);
    }
  };

  const searchStudio = async (StudioName) => {
    console.log("searchStudio", StudioName);
    let params = queryParamas;

    StudioName ? (params.name = `${StudioName}`) : delete params.name;
    setqueryParamas({ ...params });
  };

  const datefilter = async (range) => {
    let startDate = range[0];
    let endDate = range[1];
    let params = queryParamas;
    // console.log('startDate', startDate);
    // console.log('endDate', endDate);
    range[0]
      ? (params.from_date = `${moment(startDate).format("YYYY-MM-DD")}`)
      : delete params.from_date;

    range[1]
      ? (params.end_date = `${moment(endDate).format("YYYY-MM-DD")}`)
      : delete params.end_date;
    // if (range[0]) {
    // 	params.from_date = `${moment(startDate).format('YYYY-MM-DD')}`;
    // }

    // if (range[1]) {
    // 	params.end_date = `${moment(endDate).format('YYYY-MM-DD')}`;
    // }
    setqueryParamas({ ...params });
    console.log("datefilter", queryParamas);
  };

  const exportFile = () => {
    dispatch(setemptyDeleteList());
    dispatch(setemptycheckedList());
  };

  const AntSwitch = styled(Switch)(({ theme }) => ({
    width: 50,
    height: 25,
    padding: 0,
    borderRadius: 30,
    display: "flex",
    "&:active": {
      "& .MuiSwitch-thumb": {
        width: 20,
      },
      "& .MuiSwitch-switchBase.Mui-checked": {
        transform: "translateX(15px)",
      },
    },
    "& .MuiSwitch-switchBase": {
      padding: 2,
      "&.Mui-checked": {
        transform: "translateX(25px)",
        color: "#0C0D16",
        "& + .MuiSwitch-track": {
          opacity: 1,
          backgroundColor: theme.palette.mode === "dark" ? "white" : "white",
        },
      },
    },
    "& .MuiSwitch-thumb": {
      boxShadow: "0 2px 4px 0 rgb(0 35 11 / 20%)",
      width: 20,
      height: 20,
      borderRadius: 30,
      transition: theme.transitions.create(["width"], {
        duration: 200,
      }),
    },
    "& .MuiSwitch-track": {
      borderRadius: 16 / 2,
      opacity: 1,
      backgroundColor:
        theme.palette.mode === "dark" ? "rgba(0,0,0,.25)" : "rgba(0,0,0,.25)",
      boxSizing: "border-box",
    },
  }));

  const switchHandler = (event) => {
    setChecked(event.target.checked);
  };

  const clearButton = () => {
    if (userRole == "SUPER_ADMIN") {
      document.getElementById("InstructorCLearFilter").click();
    }
    document.getElementById("InstructorDropCLearFilter").click();
    document.getElementById("InstructorCLearDate").click();
    setShowFilter(!showFilter);
  };

  const options = [
    { value: "chocolate", label: "Chocolate" },
    { value: "strawberry", label: "Strawberry" },
    { value: "vanilla", label: "Vanilla" },
  ];

  useEffect(() => {
    if (window.innerWidth < 770) {
      setChecked(true);
    } else {
      setChecked(false);
    }
  }, [window.innerWidth]);

  useEffect(() => {
    if (loadApi) {
      exportapiCall();
      apiCall();
    } else {
      setloadApi(true);
    }
  }, [queryParamas]);

  useEffect(() => {
    if (userRole === "SUPER_ADMIN") {
      getAllTC();
      // getAllInst();
    }
    // getAllTC();
  }, []);

  const columns = [
    { displayName: "Instructor Name", id: "name" },
    { displayName: "Date", id: "created_at" },
    {
      displayName: "Average Session Length",
      id: "avg_sesseion_length",
    },
    {
      displayName: "Total Students",
      id: "total_students",
    },
    {
      displayName: "Average no. of disconnect",
      id: "average_no_of_disconnect",
    },
    {
      displayName: " Total Scheduled Training ",
      id: "total_scheduled_trainning",
    },
  ];

  const datas =
    multipleChecked.length > 0 ? multipleChecked : exportapiResponse;

  const closemodal = () => {
    setShowModal(false);
    setShowSingleModal(false);
  };

  const deleteList = async () => {
    const response = await axios(
      "DELETE",
      CONSTANTURL[process.env.REACT_APP_CUSTOM_ENV].LOGIN +
        API.END_POINTS.USERS +
        `?` +
        `ids=[${multipleDelete.map((value) => `"${value}"`)}]`,
      {},
      {},
      {}
    )
      .then((response) => {
        toast.success("Records Deleted", {
          position: "bottom-right",
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          style: { background: "#000", color: "#ffffff" },
        });
        apiCall();
        setShowModal(false);
        setFlag(!flag);
        dispatch(setemptyDeleteList());
        dispatch(setemptycheckedList());
        return response.data;
      })
      .catch(() => {
        setShowModal(false);
        toast.error("RECORDS NOT DELETED", {
          position: "bottom-right",
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          style: { background: "#000", color: "#ffffff" },
        });
      });
  };

  const singleDeleteModal = async () => {
    const response = await axios(
      "DELETE",
      CONSTANTURL[process.env.REACT_APP_CUSTOM_ENV].LOGIN +
        API.END_POINTS.USERS +
        `?` +
        `ids=["${singleDeleteId}"]`,
      {},
      {},
      {}
    )
      .then((response) => {
        toast.success("Record Deleted", {
          position: "bottom-right",
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          style: { background: "#000", color: "#ffffff" },
        });
        apiCall();
        setShowSingleModal(false);
        setFlag(!flag);
        return response.data;
      })
      .catch(() => {
        setShowSingleModal(false);
        toast.success("RECORDS NOT DELETED", {
          position: "bottom-right",
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
		  style: { background: "#000", color: "#ffffff" },
        });
      });
  };

  return (
    <div id="instructor">
      {showModal ? (
        <DeleteAlert closeModal={closemodal} deleteList={deleteList} />
      ) : (
        ""
      )}
      {showSingleModal ? (
        <SingleDelete
          closeModal={closemodal}
          singleDeleteModal={singleDeleteModal}
        />
      ) : (
        ""
      )}
      <div className="scrollContainer">
        <Stack direction="row" spacing={"20%"}>
          <SubHeading
            title={"Instructor"}
            checked={checked}
            switchHandler={switchHandler}
            gridview={switchHandler}
            searchChange={searchStudio}
            multipleDeleteList={multipleDeleteList}
            columns={columns}
            datas={datas}
            exportFile={exportFile}
            redirect={APP_ROUTES.ADD_INSTRUCTOR}
            setShowFilter={setShowFilter}
            showFilter={showFilter}
            exportfileTitle={"Instructor_Master_Data"}
            addText={"Add Instructor"}
          />
        </Stack>

        <div style={{ display: showFilter ? "contents" : "none" }}>
          <Stack
            direction="row"
            className="lowerFilterContain"
            justifyContent={"space-around"}
            marginTop="1%"
          >
            <Grid container>
              <Grid item flexGrow={0.2} xs={12} sm={12} md={5} lg={4}>
                <DateRangePicker
                  getdateRange={datefilter}
                  clearID={"InstructorCLearDate"}
                  // startDateProps={lastday}
                  // endDateProps={currentDate}
                />
              </Grid>
              <Grid item flexGrow={0.2} xs={6} sm={6} md={2} lg={3}>
                <Dropdown
                  clearable
                  // value={options[0]}
                  selection
                  options={uniqueName}
                  placeholder="Instructor"
                  selectDropDown={dropdownSelectInstructor}
                  clearID={"InstructorDropCLearFilter"}
                />
              </Grid>
              {userRole === "SUPER_ADMIN" ? (
                <Grid
                  item
                  flexGrow={0.3}
                  xs={6}
                  sm={6}
                  md={3}
                  lg={3}
                  // marginTop={{ xs: '1%', sm: '1%', md: '2%' }}
                >
                  <Dropdown
                    clearable
                    placeholder="Training Center"
                    options={allTC}
                    selectDropDown={dropdownSelect}
                    clearID={"InstructorCLearFilter"}
                    sx={{ borderRight: "2px solid #2C2C2C ", height: "40px" }}
                  />
                </Grid>
              ) : (
                ""
              )}
              <Grid
                item
                xs={12}
                sm={12}
                md={2}
                lg={2}
                className="marginTopInstrut"
              >
                <Button
                  className="fs-4"
                  value="Clear Filter"
                  role="clearFilter"
                  onClick={() => {
                    clearButton();
                  }}
                >
                  Clear Filter
                </Button>
              </Grid>
            </Grid>
          </Stack>
        </div>

        <>
          <Box sx={{ bgcolor: "#232135", height: "100vh" }}>
            {checked ? (
              <>
                {loading ? (
                  <MultiLine_Spinner />
                ) : (
                  <Stack direction="row" width="100%" flexWrap="wrap">
                    <InstructorCardView
                      res={apiResponse}
                      lgWidth={"4"}
                      ondeleteClick={singleDelete}
                    />
                  </Stack>
                )}
              </>
            ) : (
              <>
                {loading ? (
                  <MultiLine_Spinner />
                ) : (
                  <>
                    <Stack>
                      {apiResponse?.length > 0 ? (
                        apiResponse?.map((res) => {
                          return (
                            <Stack
                              onClick={() => {
                                // setShowDetails(true);
                              }}
                            >
                              <InstructorList
                                res={res}
                                ondeleteClick={singleDelete}
                              />
                            </Stack>
                          );
                        })
                      ) : (
                        <Stack className="NO_RECORD_FOUND">
                          No Record Found
                        </Stack>
                      )}
                    </Stack>
                  </>
                )}
              </>
            )}
          </Box>
          {/* )} */}
          {/* <Stack alignItems="end" marginTop={'-1%'}>
					<Pagination count={pageCount} onChange={onPageClickhandler} />
				</Stack> */}
        </>
      </div>
      <Stack alignItems="end" marginTop={"0.5%"}>
        <Pagination count={pageCount} onChange={onPageClickhandler} disabled={pageCount === 1}/>
      </Stack>
    </div>
  );
};

export default Instructor;
